import React, { useEffect, useRef, useState } from 'react'
import { I18n } from 'react-redux-i18n'
import ReactDOM from 'react-dom'
import { useWindowSize } from 'hooks'
import ClickOutHandler from 'react-onclickout'

import './styles.scss'
import { getStaticImage } from 'utils/statics'
import { getOperatorNameAndEmail } from 'utils/Operator'
import { assignation } from 'api'

const ListAssigned = ({ assignToOthers, user, operatorCanAssignACardToItself, assignToMyself, unassignMe }) => {
  const [hovering, setHovering] = useState(false)
  const [timer, setTimer] = useState(null)
  const [dataOperators, setDataOperators] = useState([])
  const [toggleBtnCoords, setToggleBtnCoords] = useState(null)
  const [isPortalActive, setPortalActive] = useState(false)

  const size = useWindowSize()
  const modalPortal = document.getElementById('modal-portal')
  const toggleBtnRef = useRef(null)

  useEffect(() => {
    if (toggleBtnRef?.current) {
      setToggleBtnCoords(toggleBtnRef.current.getBoundingClientRect())
    }
  }, [toggleBtnRef, size, hovering])

  useEffect(() => {
    if(!isPortalActive && hovering ) handleMouseLeave()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPortalActive])

  useEffect(() => {
    return () => cleanTimeout()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timer])

  // verificar si el mouse hace hover sobre el icono
  const handleMouseEnter = () => {
    if(!user.assignedTo?.length) return

    const timerId = setTimeout(
      async() => {
        try {
          setHovering(true)
          setPortalActive(true)
          toggleList()

          const { data } = await assignation.getUsersAssigned({
            conversationId: user._id
          })

          setDataOperators(data)
        } catch (error) {
          setPortalActive(false)
        }
      },
      2000
    )

    setTimer(timerId)
  }

  const cleanTimeout = () => {
    if (timer) {
      clearTimeout(timer)
      setTimer(null)
    }
  }

  const handleMouseLeave = () => {
    if(isPortalActive) return
    cleanTimeout()
    setHovering(false)
    if(hovering) toggleList()
  }

  const toggleList = () => {
    if(!hovering) {
      modalPortal.style.display = 'flex'
    } else {
      modalPortal.style.display = 'none'
    }
  }

  return (
    <div style={{
      position: 'relative',
    }}>
      <img
        ref={toggleBtnRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        id='assignToMeCardIcon'
        className='img-assign'
        src={getStaticImage(`/icons/orange-brand/icon-${operatorCanAssignACardToItself ? 'assign' : 'unassign'}${assignToOthers}.svg`)} alt={'assign'}
        onClick={()=> operatorCanAssignACardToItself ? assignToMyself(user) : unassignMe(user)}
        title={operatorCanAssignACardToItself ? I18n.t('dashboard_associate-conversation-for-me') : I18n.t('dashboard_remove-assignment')}
      />
      { (hovering && dataOperators.length) ? ReactDOM.createPortal(
        <ClickOutHandler onClickOut={() => setPortalActive(false) }>
          <div
            onMouseLeave={() => setPortalActive(false)}
            onClick={(e) => e.stopPropagation()}
            className='list-assigned-container animation fadeIn'
            style={{
              top: toggleBtnCoords.y + 0,
              left: toggleBtnCoords.x + 0,
            }}
          >
            {dataOperators.map(({ email, name, lastname, _id }) => (
              <div
                className='list-assigned-container__card'
                key={_id}
              >
                <span className='list-assigned-container__card--text text-ellipsis'>
                  {getOperatorNameAndEmail({ email, name, surname: lastname })}
                </span>
              </div>
            ))}
          </div>
        </ClickOutHandler>,
        modalPortal
      ):null}
    </div>
  )
}

export default ListAssigned